<template>
    <div
        class="product-option-groups d-flex flex-column"
    >
        <article
            v-for="(group, index) in groups"
            :key="`product-option-group-${index}`"
        >
            <ProductOptionGroup
                v-if="group.groupValues.length"
                :group="group"
            ></ProductOptionGroup>
        </article>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductOptionGroup as ProductOptionGroupType
    } from '~/types';

    import ProductOptionGroup from '~/components/products/product/ProductOptionGroup/ProductOptionGroup.vue';

    defineProps<{
        groups: ProductOptionGroupType[];
    }>();
</script>

<style lang="scss"></style>
